import crypto from 'crypto';
export default {
  randomUUID: crypto.randomUUID
};